import { t } from '@lingui/macro';
import BanIcon from '@patternfly/react-icons/dist/esm/icons/ban-icon';
import React from 'react';
import { EmptyStateCustom } from './empty-state-custom';

export const EmptyStateGroupAccessDenied = () => {
  return (
    <EmptyStateCustom
      icon={BanIcon}
      title={t`Access denied`}
      description={t`You do not have the required group membership to access this service. Please contact your administrator to request access.`}
    />
  );
};
